const BaseXform = require('../../base-xform');
// const AGraphicDataXform = require('./c-chart-xform');
const CTitle = require('../title/c-title-xform');

class ValTitleXform extends BaseXform {
  constructor() {
    super();

    this.map = {
      'c:title': new CTitle(),
    };
  }

  get tag() {
    return 'c:valAx';
  }

  render(xmlStream, model) {
    xmlStream.openNode(this.tag);
    this.map['c:title'].render(xmlStream, model);
    xmlStream.closeNode();
  }

  parseOpen(node) {
    if (this.parser) {
      this.parser.parseOpen(node);
      return true;
    }

    switch (node.name) {
      case this.tag:
        this.reset();
        break;

      default:
        this.parser = this.map[node.name];
        if (this.parser) {
          this.parser.parseOpen(node);
        }
        break;
    }
    return true;
  }

  parseText(text) {
    if (this.parser) {
      this.parser.parseText(text);
    }
  }

  parseClose(name) {
    if (this.parser) {
      if (!this.parser.parseClose(name)) {
        this.parser = undefined;
      }
      return true;
    }
    switch (name) {
      case this.tag:
        this.model = {
          valTitle: (this.map['c:title'].model || {}).title,
        };
        return false;
      default:
        return true;
    }
  }
}

module.exports = ValTitleXform;
